<template>
    <div class="section-container container-fixed">
        <div class="row justify-content-center">
            <div v-if="users.length <= 0" class="col-md-10 mb-2 text-center">
                <div class="generic-container">
                    <span v-if="loadingUsers">
                        {{ 'LEADERBOARD.LOADING' | translate }}
                    </span>
                    <span v-else>
                        {{ 'LEADERBOARD.NO_LEADERS' | translate }}
                    </span>  
                </div>
            </div>
            <div class="col-10">
                <div v-if="users.length > 0" class="leaders-container">
                    <header class="overview-header text-center">   
                        <sub>{{ 'LEADERBOARD.SHOWING' | translate }} {{ users.length }} {{ 'LEADERBOARD.USERS' | translate }}</sub>
                    </header>
                    <div v-for="(user, index) in users.slice(0, 10)" :key="index" class="row no-gutters text-center leaders-row">
                        <div class="col-12 col-sm-1">                     
                            <header>
                                {{ 'LEADERBOARD.RANK' | translate }}
                            </header>
                            <div class="leaders-content">
                               {{ index + 1 }}
                            </div> 
                        </div>
                        <div class="col-12 col-sm-5 address-col">
                            <header>
                                {{ 'LEADERBOARD.USER' | translate }}
                            </header>
                            <div class="leaders-content">
                                {{ user.address }}
                            </div>                          
                        </div>
                        <div class="col-12 col-sm-2">                          
                            <header>
                                {{ 'WIN_COUNT' | translate }}
                            </header>
                            <div class="leaders-content">
                                {{ user.winCount }}
                            </div> 
                        </div>
                        <div class="col-12 col-sm-2">                          
                            <header>
                                {{ 'LOSS_COUNT' | translate }}
                            </header>
                            <div class="leaders-content">
                                {{ user.lossCount }}
                            </div> 
                        </div>
                        <div class="col-12 col-sm-2">                        
                            <header>
                                {{ 'EARNINGS' | translate }}
                            </header>
                            <div class="leaders-content">
                                {{ fromWei(user.earnings) }} NAS
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { neb } from "../util/nebulas";

export default {
    name: 'leaderboard',
    components: { },
    computed: {
        ...mapGetters({
            users: 'getUsers',
            loadingUsers: 'getLoadingUsers'
        })
    },
    data() {
        return {};
    },
    methods: {
        isMe (address) {
            // return this.user.address == address;
        },
        fromWei (amount) {
            return neb.fromBasic(amount, "nas").toNumber();  
        }
    }
}
</script>

<style scoped lang="less">
@import "../assets/less/generic.less";
@bgAccentColor: #3F4353;

.alert-warning {
    border: 1px solid @bgAccentColor;
    text-align: center;
    border-radius: 0;
    margin: 0;
}

.generic-container {
    padding: 40px;
    margin: 0 5px;
    color: #efefef;
    background: @bgAccentColor;
}

.leaders-container {
    .overview-header {
        padding: 20px 30px 30px;
        color: #fff;
        font-size: 20px;
        background: @bgAccentColor;
        border-bottom: 3px solid #222532;

        sub {
            color: #ccc;
        }
    }
    .leaders-row {
        padding: 25px 20px;
        color: #fff;
        background: @bgAccentColor;
        border-bottom: 3px solid #222532;

        header {
            font-size: 12px;
            color: #ccc;
            padding-bottom: 10px;
        }

        .address-col {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

// Phone device
@media only screen and (max-width: 480px) {
    .leaders-container {
        .leaders-row {
            padding: 0;

            [class^='col'] {
                padding: 20px;
            }
        }

        .address-col {
            font-size: 13px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/LeaderBoard.vue